import { useContext } from "react";

import type { TFieldsLoadingContext } from "../types";
import OrderFieldsLoadingContext from "./OrderFieldsLoadingContext";

const useOrderFieldsLoading = (): TFieldsLoadingContext => {
  const context = useContext(OrderFieldsLoadingContext);
  if (!context) {
    throw new Error("useOrderFieldsLoading must be used within a OrderFieldsLoadingContext");
  }
  return context;
};

export default useOrderFieldsLoading;
